module.exports = "/_next/static/images/bank-953483290e4a043d45fb4f9a7a1764b1.svg";